import pluginGemoji from '@tarslib/bytemd-plugin-gemoji';
import type { BytemdSafeMdxViewerPlugin } from '@tarslib/bytemd-processor';
import { SupportIconTextReplacer } from '../MarkdownSafeMdxViewer/Components/Icon/parser';

const pluginViewerInsertIcon: BytemdSafeMdxViewerPlugin = {
  remark: pluginGemoji().remark,
  mdxHandlerList:
    ({ childrenFactory }) =>
    (input) => {
      if ('res' in input) return input;
      const node = input.source;
      if (node.type !== 'text') return input;
      if (!node.value) {
        return {
          res: null,
        };
      }

      const replaceResult = SupportIconTextReplacer(node.value, (data) => data);
      if (typeof replaceResult === 'string') {
        node.value = replaceResult;
        return input;
      } else {
        return {
          res: childrenFactory({
            type: 'mdxJsxTextElement',
            children: replaceResult,
          }),
        };
      }
    },
};

export default pluginViewerInsertIcon;
